import { useState } from "react";

const KEY = "secretariat-theme";
export const getTheme = () => localStorage.getItem(KEY) || "dark";
export const applyTheme = (t) => {
  document.documentElement.classList.toggle("dark", t === "dark");
  localStorage.setItem(KEY, t);
};

export function useTheme() {
  const [t, setT] = useState(getTheme());
  const toggle = () => {
    const n = t === "dark" ? "light" : "dark";
    applyTheme(n);
    setT(n);
  };
  return [t, toggle];
}
